module.exports = __webpack_public_path__ + "img/medicalschool-25965-037-474x316.bb4b6e1f.jpg";